export default __webpack_public_path__ + "static/media/splashScreen.f08e6cba.png";